import type { VintageSchema } from "@/marketplace/typings/vintage"

export const getVintageKey = (vintage: Pick<VintageSchema, "year" | "impactType">) => {
  return `${vintage.year}-${vintage.impactType}`
}
